
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import bannerStyle from './banner.module.css'
import Slider from "react-slick";
import AnchorLink from "../AnchorLink";
import {  FaArrowRightLong,FaArrowLeftLong } from "react-icons/fa6";

const Banner = () => {

    const SampleNextArrow = (props) => {
        const { onClick } = props;
        return (
            <div className="slick-custom-arrow prev" onClick={onClick}>
                <FaArrowRightLong size={20}/>
            </div>
        );
    }

    const SlickPrevArrow = (props)  => {
        const {onClick } = props;
        return (
            <div className="slick-custom-arrow next" onClick={onClick}>
                <FaArrowLeftLong size={20} />
            </div>
        );
    }

    const settings = {
        className: "center",        
        centerMode: true,
        infinite: true,
        arrows:true,
        centerPadding: "220px",
        slidesToShow: 1,        
        speed: 2000,
        pauseOnHover: true,
        nextArrow:<SampleNextArrow />,
        prevArrow:<SlickPrevArrow />,
        responsive: [{
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,  
              centerMode: false,     
              arrows:false,       
            }
          }]
    };

    return (
        <section className='bg-black section-1'>
        <Slider
             {...settings}
        >
            <div className='position-relative mt-0 mt-xl-5 pt-0 pt-xl-5'>
                <div className={bannerStyle['banner-content']}>
                    <h1>Headding</h1>      
                    <div className="other-content mt-3">
                        <p>It is possible to have your IT services delivered with exceptional communication and project management. Let us prove it.</p>                        
                        <AnchorLink 
                            title={'Know More'}   
                            href="#"  
                            icon={''}                    
                        />
                    </div>              
                </div>
                <div className="slider-image" style={{backgroundImage:"url(/banner/manage-service-banner.png)"}}></div>
            </div>
            <div className='position-relative mt-0 mt-xl-5 pt-0 pt-xl-5'>
                <div className={bannerStyle['banner-content']}>
                    <h1>Headding 2</h1> 
                    <div className="other-content mt-3">
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos dolores nam unde maxime quas, quasi corrupti qui repudiandae, </p>                   
                        <AnchorLink 
                            title={'Know More'}   
                            href="#"  
                            icon={''}                    
                        />
                    </div>
                </div>
                <div className="slider-image" style={{backgroundImage:"url(/banner/banner-homev2.jpg)"}}></div>
            </div>
            <div className='position-relative mt-0 mt-xl-5 pt-0 pt-xl-5'>
                <div className={bannerStyle['banner-content']}>
                    <h1>Headding 3</h1>       
                    <div className="other-content mt-3">
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos dolores nam unde maxime quas, quasi corrupti qui repudiandae, </p>                   
                        <AnchorLink 
                            title={'Know More'}   
                            href="#"  
                            icon={''}                    
                        />
                    </div>          
                </div>
                <div className="slider-image" style={{backgroundImage:"url(/banner/home-banner-v5.jpg)"}}></div>
            </div>
            <div className='position-relative mt-0 mt-xl-5 pt-0 pt-xl-5'>
                <div className={bannerStyle['banner-content']}>
                    <h1>Headding 3</h1>  
                    <div className="other-content mt-3">
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dignissimos dolores nam unde maxime quas, quasi corrupti qui repudiandae, </p>                   
                        <AnchorLink 
                            title={'Know More'}   
                            href="#"  
                            icon={''}                    
                        />
                    </div>                 
                </div>
                <div className="slider-image" style={{backgroundImage:"url(/banner/home-banner-v5.jpg)"}}></div>
            </div>
        </Slider>
        </section>
    );
};

export default Banner;